import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import sb from '@/utils/sb'
import { supabaseAuthActions } from '@/utils/store/supabaseAuth'
import { type ActionFunctionArgs, Link, redirect, useFetcher } from 'react-router'

export const action = async ({ request }: ActionFunctionArgs) => {
  const supabase = sb;

  const formData = await request.formData()

  const email = formData.get('email') as string
  const password = formData.get('password') as string

  const { error } = await supabase.auth.signInWithPassword({
    email,
    password,
  })

  if (error) {
    return {
      error: error instanceof Error ? error.message : 'An error occurred',
    }
  }

  // 更新认证状态
  await supabaseAuthActions.update();

  // Update this route to redirect to an authenticated route. The user already has an active session.
  return redirect('/', {  })
  // return redirect('/protected', {  })
}

export default function Login() {
  const fetcher = useFetcher<typeof action>()

  const error = fetcher.data?.error
  const loading = fetcher.state === 'submitting'

  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10 bg-gradient-to-b from-slate-50 to-gray-100">
      <div className="w-full max-w-sm">
        <div className="flex flex-col gap-6">
          <Card className="shadow-lg border border-gray-100 bg-white">
            <CardHeader className="space-y-1 pb-4">
              <CardTitle className="text-2xl font-semibold tracking-tight">登录</CardTitle>
              <CardDescription className="text-gray-500">请输入您的邮箱以登录您的账户</CardDescription>
            </CardHeader>
            <CardContent>
              <fetcher.Form method="post">
                <div className="flex flex-col gap-5">
                  <div className="grid gap-2">
                    <Label htmlFor="email" className="text-sm font-medium text-gray-700">邮箱</Label>
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      placeholder="m@example.com"
                      required
                      className="h-10 rounded-lg border-gray-200 focus:border-gray-400 focus:ring-gray-400/20"
                    />
                  </div>
                  <div className="grid gap-2">
                    <div className="flex items-center">
                      <Label htmlFor="password" className="text-sm font-medium text-gray-700">密码</Label>
                      <Link
                        to="/s_auth/forgot-password"
                        className="ml-auto inline-block text-sm text-gray-500 hover:text-gray-700 underline-offset-4 hover:underline transition-colors"
                      >
                        忘记密码？
                      </Link>
                    </div>
                    <Input 
                      id="password" 
                      type="password" 
                      name="password" 
                      required 
                      className="h-10 rounded-lg border-gray-200 focus:border-gray-400 focus:ring-gray-400/20"
                    />
                  </div>
                  {error && (
                    <div className="p-3 bg-red-50 border border-red-100 rounded-lg">
                      <p className="text-sm text-red-600">{error}</p>
                      <p className="text-xs text-red-500 mt-1">由于安全策略升级，11月09日前注册的用户密码废弃，需要重置密码</p>
                    </div>
                  )}
                  <Button 
                    type="submit" 
                    className="w-full h-10 rounded-lg bg-gray-900 hover:bg-gray-800 text-white font-medium transition-colors" 
                    disabled={loading}
                  >
                    {loading ? '登录中...' : '登录'}
                  </Button>
                </div>
                <div className="mt-5 text-center text-sm text-gray-500">
                  还没有账户？{' '}
                  <Link to="/s_auth/sign-up" className="text-gray-700 font-medium underline underline-offset-4 hover:text-gray-900 transition-colors">
                    注册
                  </Link>
                </div>
              </fetcher.Form>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  )
}
